var event_registration = (function( $ ) {

	var $form;

	var _init = function() {
		$form = $( '#event_registration_form' );

		if ( $form.length > 0 ) {
			$form.find( 'select#event_registration_form-ticket_type' ).on( 'change', _update_price );
		}
	};

	var _update_price = function( e ) {
		var pricing = $( this ).data( 'pricing' );
		var val = $( this ).val();

		var price = {};

		for ( var i = 0; i < pricing.length; i++ ) {
			if ( parseInt( pricing[ i ]['ID'] ) === parseInt( val ) ) {
				price = pricing[ i ];
				break;
			}
		}

		$( '#event-info-box' ).find( '.price .info-value' ).html( '&euro;' + price.price );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = event_registration;